import React, { useState, useEffect } from 'react'
import { useGeneralApp } from '../../hooks/useGeneralApp'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { LoginPage } from '../../pages/Login'
import { data } from '../../data/index'

export const AuthGuard = (props) => {
  const { isLoading } = useGeneralApp()
  const { typeUser } = props
  const auth = useAuth()
  const location = useLocation()
  const [requestedLocation, setRequestedLocation] = useState(null)
  useEffect(() => {}, [isLoading])

  if (!auth.isAuthenticated) {
    if (isLoading === false) {
      if (location.pathname !== requestedLocation) {
        setRequestedLocation(location.pathname)
      }
      return <LoginPage />
    }
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null)
    return <Navigate to={requestedLocation} />
  }
  // Redireccionar dependiendo el tipo de usuario
  // if type user is null go to solicitated route
  // if type user is not null go to home
  if (isLoading === false) {
    if (typeUser.includes(auth.user.typeUser)) {
      return <Outlet/>
    } else {
      if (auth.user.typeUser === data.userRoles.organizador) {
        return <Navigate to="/mi-cuenta/reservaciones" />
      }
      if (auth.user.typeUser === data.userRoles.espectador) {
        return <Navigate to="/mi-cuenta/reservaciones" />
      }
      if (auth.user.typeUser === data.userRoles.administrador) {
        return <Navigate to="/dashboard" />
      }
    }
  }
}
